// Vendor
import { ElementRef, EventEmitter } from '@angular/core';
// Services
import { DropdownHelperService } from 'NewAngular/services/dropdown-helper.service';
import * as i0 from "@angular/core";
import * as i1 from "NewAngular/services/dropdown-helper.service";
import * as i2 from "@angular/common";
import * as i3 from "../../../../../../../ycharts/static/ts/features/directives/icon/icon.directive";
const _c0 = ["securityHeaderDropdown"];
const _c1 = a0 => ({ disabled: a0 });
const _c2 = a0 => ({ show: a0 });
const _c3 = a0 => ({ "dropdown-item-text-with-new": a0 });
function SecurityHeaderDropdownComponent__svg_svg_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(0, "svg", 6);
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("name", ctx_r1.dropdownConfig.title.icon);
} }
function SecurityHeaderDropdownComponent_div_7_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 11);
} }
function SecurityHeaderDropdownComponent_div_7_div_2__svg_svg_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(0, "svg", 6);
} if (rf & 2) {
    const listItem_r4 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵproperty("name", listItem_r4.icon);
} }
function SecurityHeaderDropdownComponent_div_7_div_2__svg_svg_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(0, "svg", 6);
} if (rf & 2) {
    i0.ɵɵproperty("name", "icon-new");
} }
function SecurityHeaderDropdownComponent_div_7_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 12);
    i0.ɵɵlistener("click", function SecurityHeaderDropdownComponent_div_7_div_2_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r3); const listItem_r4 = i0.ɵɵnextContext().$implicit; const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.submit(listItem_r4)); });
    i0.ɵɵtemplate(1, SecurityHeaderDropdownComponent_div_7_div_2__svg_svg_1_Template, 1, 1, "svg", 3);
    i0.ɵɵelement(2, "div", 13);
    i0.ɵɵtemplate(3, SecurityHeaderDropdownComponent_div_7_div_2__svg_svg_3_Template, 1, 1, "svg", 3);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const listItem_r4 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(5, _c1, listItem_r4.disabled));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", listItem_r4.icon);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(7, _c3, ctx_r1.dropdownConfig.hasNew))("textContent", listItem_r4.label);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", listItem_r4.isNew);
} }
function SecurityHeaderDropdownComponent_div_7_div_3__svg_svg_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(0, "svg", 6);
} if (rf & 2) {
    const listItem_r4 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵproperty("name", listItem_r4.icon);
} }
function SecurityHeaderDropdownComponent_div_7_div_3__svg_svg_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(0, "svg", 6);
} if (rf & 2) {
    i0.ɵɵproperty("name", "icon-new");
} }
function SecurityHeaderDropdownComponent_div_7_div_3_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 18);
    i0.ɵɵlistener("click", function SecurityHeaderDropdownComponent_div_7_div_3_div_6_Template_div_click_0_listener() { const submenuItem_r6 = i0.ɵɵrestoreView(_r5).$implicit; const ctx_r1 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r1.submit(submenuItem_r6)); });
    i0.ɵɵelementStart(1, "div", 19);
    i0.ɵɵelement(2, "img", 20);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 21);
    i0.ɵɵelement(4, "strong", 22);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const submenuItem_r6 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("src", submenuItem_r6.logoSource, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("textContent", submenuItem_r6.label);
} }
function SecurityHeaderDropdownComponent_div_7_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 14)(1, "div", 15);
    i0.ɵɵtemplate(2, SecurityHeaderDropdownComponent_div_7_div_3__svg_svg_2_Template, 1, 1, "svg", 3);
    i0.ɵɵelement(3, "div", 13);
    i0.ɵɵtemplate(4, SecurityHeaderDropdownComponent_div_7_div_3__svg_svg_4_Template, 1, 1, "svg", 3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 16);
    i0.ɵɵtemplate(6, SecurityHeaderDropdownComponent_div_7_div_3_div_6_Template, 5, 2, "div", 17);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const listItem_r4 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(7, _c1, listItem_r4.disabled));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", listItem_r4.icon);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(9, _c3, ctx_r1.dropdownConfig.hasNew))("textContent", listItem_r4.label);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", listItem_r4.isNew);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(11, _c2, ctx_r1.isSubmenuOpen));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", listItem_r4.subMenu);
} }
function SecurityHeaderDropdownComponent_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵtemplate(1, SecurityHeaderDropdownComponent_div_7_div_1_Template, 1, 0, "div", 8)(2, SecurityHeaderDropdownComponent_div_7_div_2_Template, 4, 9, "div", 9)(3, SecurityHeaderDropdownComponent_div_7_div_3_Template, 7, 13, "div", 10);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const listItem_r4 = ctx.$implicit;
    i0.ɵɵproperty("ngSwitch", listItem_r4.type);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "divider");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "option");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "submenu");
} }
/**
 * SecurityHeaderDropdownComponent.
 *
 * Action dropdown menu for the security header.
 */
export class SecurityHeaderDropdownComponent {
    constructor(dropdownHelperService) {
        this.dropdownHelperService = dropdownHelperService;
        this.handler = new EventEmitter();
        this.isMainOpen = false;
        this.isSubmenuOpen = false;
    }
    ngAfterViewInit() {
        // Setup DropdownHelperService to close the dropdown when the user clicks outside.
        const autoCloseHandler = () => {
            this.isSubmenuOpen = false;
            this.isMainOpen = false;
        };
        this.dropdownHelperService.setCloseHandler(this.securityHeaderDropdown.nativeElement, autoCloseHandler);
    }
    /**
     * Shows or hides the dropdown menu.
     */
    toggleMainOpen() {
        if (!this.inputDisabled)
            this.isMainOpen = !this.isMainOpen;
    }
    /**
     * Emits the `handler` function when a dropdown item is selected and then hide it.
     *
     * @param listItem: Selected item from the dropdown menu.
     */
    submit(listItem) {
        if (!listItem.disabled)
            this.handler.emit(listItem);
        this.isSubmenuOpen = false;
        this.isMainOpen = false;
    }
}
SecurityHeaderDropdownComponent.ɵfac = function SecurityHeaderDropdownComponent_Factory(t) { return new (t || SecurityHeaderDropdownComponent)(i0.ɵɵdirectiveInject(i1.DropdownHelperService)); };
SecurityHeaderDropdownComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SecurityHeaderDropdownComponent, selectors: [["ycn-security-header-dropdown"]], viewQuery: function SecurityHeaderDropdownComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.securityHeaderDropdown = _t.first);
    } }, inputs: { buttonClass: "buttonClass", dropdownConfig: "dropdownConfig", inputDisabled: "inputDisabled", dropdownClass: "dropdownClass", submenuClass: "submenuClass" }, outputs: { handler: "handler" }, decls: 8, vars: 14, consts: [["securityHeaderDropdown", ""], [1, "dropdown"], [3, "click", "ngClass"], ["ycnIcon", "", 3, "name", 4, "ngIf"], [3, "ngClass"], [3, "ngSwitch", 4, "ngFor", "ngForOf"], ["ycnIcon", "", 3, "name"], [3, "ngSwitch"], ["class", "dropdown-divider", 4, "ngSwitchCase"], ["class", "dropdown-item", 3, "ngClass", "click", 4, "ngSwitchCase"], ["class", "dropdown dropdown-nested", 4, "ngSwitchCase"], [1, "dropdown-divider"], [1, "dropdown-item", 3, "click", "ngClass"], [1, "dropdown-item-text", 3, "ngClass", "textContent"], [1, "dropdown", "dropdown-nested"], [1, "dropdown-item", "dropdown-toggle", 3, "ngClass"], [1, "dropdown-menu", "dropdown-menu-right", 3, "ngClass"], ["class", "dropdown-item", 3, "click", 4, "ngFor", "ngForOf"], [1, "dropdown-item", 3, "click"], [1, "dropdown-item-logo"], [3, "src"], [1, "dropdown-item-text"], [3, "textContent"]], template: function SecurityHeaderDropdownComponent_Template(rf, ctx) { if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "div", 1, 0)(2, "div", 2);
        i0.ɵɵlistener("click", function SecurityHeaderDropdownComponent_Template_div_click_2_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.toggleMainOpen()); });
        i0.ɵɵtemplate(3, SecurityHeaderDropdownComponent__svg_svg_3_Template, 1, 1, "svg", 3);
        i0.ɵɵelementStart(4, "span");
        i0.ɵɵtext(5);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(6, "div", 4);
        i0.ɵɵtemplate(7, SecurityHeaderDropdownComponent_div_7_Template, 4, 4, "div", 5);
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵclassMap(ctx.buttonClass);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(10, _c1, ctx.inputDisabled));
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.dropdownConfig.title.icon);
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate1(" ", ctx.dropdownConfig.title.icon ? "\u00A0" + ctx.dropdownConfig.title.label : ctx.dropdownConfig.title.label, " ");
        i0.ɵɵadvance();
        i0.ɵɵclassMapInterpolate1("dropdown-menu ", ctx.dropdownClass, "");
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(12, _c2, ctx.isMainOpen));
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngForOf", ctx.dropdownConfig.list);
    } }, dependencies: [i2.NgClass, i2.NgForOf, i2.NgIf, i2.NgSwitch, i2.NgSwitchCase, i3.IconDirective], encapsulation: 2 });
